// src/api/endpoints.ts

export const ENDPOINTS = {


  // Role Permissions
ROLE_PERMISSIONS_BY_EMPLOYEE_CODE:
  '/role-permissions/get-by-employee-code',

EMPLOYEE_ROLE_PERMISSIONS:
  '/role-permissions/get-employee-role-permissions',



  DASHBOARD_KPI:
    '/dashboard/kpi',

  TEAM_ACTIVE_HOURS:
    '/dashboard/team-active-hours',

  PRODUCTIVITY_CHART:
    '/dashboard/productivity-chart',

  TIME_ALLOCATION_CHART:
    '/dashboard/time-allocation-chart',

  APP_LIST:
    '/dashboard/app-list',

  TEAM_KPI:
    '/master-dashboard/dashboard-summary/get-all',

  KPI_TREND:
    '/master-dashboard/kpi-trend/get-all',

  TEAM_TABLE:
    '/master-dashboard/dashboard-grid-data/get-all',

  EMPLOYEE_DAY_DETAILS:
    '/master-dashboard/employee-day-details/get-all',

  SPAN_OF_CONTROL_HEADER:
    '/master-dashboard/span-of-control-header/get-all',

 TEAM_PRODUCTIVITY_COMPARISON:
    '/master-dashboard/team-productivity-comparison/get-all',

  SPAN_TIME_ALLOCATION:
    '/master-dashboard/span-time-allocation/get-all',

  TOP_APPLICATIONS:
    '/master-dashboard/top-applications/get-all',

  HEATMAP:
    '/master-dashboard/heatmap/get-all',

    //Team Active Hours

    TEAM_ACTIVE_HOURS_TEAM_LEADS:
  '/manager-dashboard/team-active-hours/team-leads',

    // Employee Dashboard

  EMPLOYEE_KPI_TRENDS:
    '/dashboard-insights/employee/kpi-trends',

  EMPLOYEE_DAILY_ACTIVITY_BREAKDOWN:
  '/dashboard-insights/employee/daily-activity-breakdown',
    
  EMPLOYEE_PRODUCTIVITY_INSIGHTS:
  '/dashboard-insights/employee/productivity-insights',

  EMPLOYEE_MONTHLY_AVG_PRODUCTIVITY:
  '/dashboard-insights/employee/monthly-avg-productivity',

  EMPLOYEE_SUMMARY:
  '/dashboard-insights/employee/summary',

  EMPLOYEE_TOP_APPLICATIONS:
  '/dashboard-insights/employee/top-applications',

  EMPLOYEE_WEEKLY_HOURS_VS_TARGET:
'/dashboard-insights/employee/weekly-hours-vs-target',

  AT_RISK_ASSOCIATES:
  '/master-dashboard/at-risk-associates/get-all',

 EMPLOYEE_LOGGED_HOURS:
    '/dashboard-insights/employee/logged-hours/get-all',


// Authentication

 LOGIN: '/auth/login',

ENCRYPT_EMPLOYEE_CODE:
  '/Encrypt',

LOGIN_SSO:
  '/Sagility-WorkVista/LoginSSO',


  // =========================
// Idle Time Report
// =========================

IDLE_TIME_KPI_CARD:
  '/dashboard-insights/manager/idle-time-report/kpi-card',

IDLE_TIME_TEAM_CHART:
  '/dashboard-insights/manager/idle-time-report/team-chart',

IDLE_TIME_BREAKDOWN:
  '/dashboard-insights/manager/idle-time-report/breakdown',

IDLE_TIME_TREND:
  '/dashboard-insights/manager/idle-time-report/idle-trend',

ASSOCIATE_IDLE_DETAILS:
  '/dashboard-insights/manager/idle-time-report/associate-idle-details',

// ======================
// At Risk Associates
// ======================


RISK_TREND: 
  '/master-dashboard/risk/trend/get-all',

RISK_KPI_CARDS:
  '/master-dashboard/risk/kpi-cards/get-all',

 RISK_BY_TEAM:
    '/master-dashboard/risk/by-team/get-all',

  RISK_ASSOCIATE_REGISTER:
    '/master-dashboard/risk/associate-register/get-all',

RISK_REASON_BREAKDOWN:
  '/master-dashboard/risk/reason-breakdown/get-all',


  //productivityReport

  PRODUCTIVITY_KPI_CARDS:
  '/master-dashboard/productivity/kpi-cards/get-all',

  PRODUCTIVITY_TEAM:
'/master-dashboard/productivity/team/get-all',

PRODUCTIVITY_WTD_TREND:
'/master-dashboard/productivity/wtd-trend/get-all',

PRODUCTIVITY_ASSOCIATE:
'/master-dashboard/productivity/associate/get-all',

PRODUCTIVITY_APP_MIX:
'/master-dashboard/productivity/productive-app-mix/get-all',

PRODUCTIVITY_DISTRIBUTION:
'/master-dashboard/productivity/distribution/get-all',


// ==========================================
// Employee Active Hours Report
// ==========================================

EMPLOYEE_ACTIVE_HOURS_KPI_CARDS:
  '/dashboard-insights/employee/active-hours/active-kpi-cards',

EMPLOYEE_HOURLY_ACTIVE_MINUTES:
  '/dashboard-insights/employee/active-hours/hourly-active-minutes',

EMPLOYEE_TIME_UTILISATION:
  '/dashboard-insights/employee/time-utilization',

EMPLOYEE_WTD_ACTIVE_HOURS:
  '/dashboard-insights/employee/active-hours/wtd-active-hours',

EMPLOYEE_ME_VS_TEAM:
  '/dashboard-insights/active-hours/employee/me-vs-team',

EMPLOYEE_FOCUS_BLOCKS:
  '/dashboard-insights/employee/focus-blocks',

EMPLOYEE_ACTIVE_HOURS_HISTORY_30_DAYS:
  '/dashboard-insights/active-hours/employee/history-30days',

EMPLOYEE_WEEKLY_ACTIVE_HOURS_DETAIL:
  '/dashboard-insights/employee/active-hours/weekly-active-hours-detail',


  // Employee Logged Hours
LOGGED_HOURS_KPI:
  '/dashboard-insights/logged-hours/employee/kpi',

LOGGED_HOURS_SESSION_LOG:
  '/dashboard-insights/employee/logged-hours/session-log',

LOGGED_HOURS_WTD:
  '/dashboard-insights/employee/logged-hours/wtd-logged',

LOGGED_HOURS_30DAY:
  '/dashboard-insights/employee/logged-hours/30day-logged',

LOGGED_HOURS_TIME_SPLIT:
  '/dashboard-insights/employee/logged-hours/time-split',

LOGGED_HOURS_ME_VS_TEAM:
  '/dashboard-insights/employee/me-vs-team-logged',

LOGGED_HOURS_DAILY_LOG:
  '/dashboard-insights/employee/daily-log',

LOGGED_HOURS_HOURLY:
  '/dashboard-insights/employee/logged-hours/hourly-logged',


  
// ==========================================
// Employee idle Report
// ==========================================

EMPLOYEE_IDLE_KPI:
'/dashboard-insights/employee/idle-hours/kpis',

EMPLOYEE_IDLE_WTD_TREND:
'/dashboard-insights/employee/idle/wtd-trend',

EMPLOYEE_IDLE_HOURLY:
'/dashboard-insights/employee/idle-hours/hourly-trend',

EMPLOYEE_IDLE_DAILY:
'/dashboard-insights/employee/idle-hours/daily-detail',

EMPLOYEE_IDLE_ME_VS_TEAM:
'/dashboard-insights/employee/idle-hours/me-vs-team',

// ==========================================
// Employee Productivity Report
// ==========================================
EMPLOYEE_PRODUCTIVITY_KPI:
'/dashboard-insights/employee/productivity-hours/kpis',

EMPLOYEE_PRODUCTIVITY_WTD_TREND:
'/dashboard-insights/employee/productivity-hours/wtd-trend',

EMPLOYEE_PRODUCTIVITY_TIME_CLASSIFICATION:
'/dashboard-insights/employee/productivity-hours/time-classification',

EMPLOYEE_PRODUCTIVITY_MONTHLY_TREND:
'/dashboard-insights/employee/productivity-hours/monthly-trend',

EMPLOYEE_PRODUCTIVITY_ME_VS_TEAM:
'/dashboard-insights/employee/productivity-hours/me-vs-team',

EMPLOYEE_PRODUCTIVITY_HOURLY_TREND:
'/dashboard-insights/employee/productivity-hours/hourly-trend',

EMPLOYEE_PRODUCTIVITY_APPLICATION_DETAIL:
'/dashboard-insights/employee/productivity-hours/application-detail',

// ==========================================
// Employee Compliance Dashboard
// ==========================================

EMPLOYEE_COMPLIANCE_KPI:
'/dashboard-insights/employee/compliance/kpi',

EMPLOYEE_COMPLIANCE_LOGIN_TREND:
'/dashboard-insights/employee/compliance/login-trend',

EMPLOYEE_COMPLIANCE_HOURS_REQUIREMENT:
'/dashboard-insights/employee/compliance/hours-requirement',

EMPLOYEE_COMPLIANCE_POLICY:
'/dashboard-insights/employee/compliance/policy-compliance',

EMPLOYEE_COMPLIANCE_MONTHLY_SCORECARD:
'/dashboard-insights/employee/compliance/monthly-scorecard',



// ==========================================
// NT ID Management
// ==========================================

EMPLOYEE_NETWORK_MAPPING:
'/employee-network-mapping/get-all',

NTID_ADD_EMPLOYEE:
'/employee-network-mapping/add',

NTID_UPDATE_EMPLOYEE: '/employee-network-mapping',

NTID_DELETE_EMPLOYEE:
'/employee-network-mapping/delete',

NTID_BULK_IMPORT:
'/employee-network-mapping/bulk-import',

NTID_EXPORT:
'/employee-network-mapping/export',

NTID_ROLES:
'/master-role/get-all',

NTID_SHIFTS:
'/employee-shift/get-all',

NTID_STATUSES:
'/access-administration/nt-id-management/statuses',

NTID_TEAMS:
'/access-administration/nt-id-management/teams',

NTID_REPORTING_MANAGERS:
'/access-administration/nt-id-management/reporting-managers',

NTID_EMPLOYEE_DETAILS:
'/employee-network-mapping/get-by-employee-code',

// ==========================================
// Public Reports
// ==========================================

PUBLIC_ACTIVITY_LOG_EXPORT:
  '/employee-activity-log-summary/exportrawcsv',

PUBLIC_SUMMARY_REPORT_EXPORT:
  '/employee-activity-log-summary/ExportCsv',

ACCESS_CREATION_REPORT:
  '/access-reports/access-creation',

ACCESS_REVOCATION_REPORT:
  '/reports/access-management/access-revocation',

ACCESS_MODIFICATION_REPORT:
  '/reports/access-management/access-modification',

  // Tracking Report
TRACKING_INSTALLATION_COMPLIANCE_REPORT:
  '/tracking/installation-compliance-report',

};